import {Component, Input, OnInit} from "@angular/core";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import * as fromStore from '../../../../../store';
import {distinctUntilChanged, filter} from "rxjs/operators";
import {TypeUtils} from "../../../../../shared/utils/type-utils";
import {Store} from "@ngrx/store";

@Component({
    selector: 'db-add-custom-domain-success',
    templateUrl: './add-custom-domain-success-dialog.component.html',
    styleUrls: ['./add-custom-domain-success-dialog.component.scss'],
    standalone: false
})
export class AddCustomDomainSuccessDialogComponent implements OnInit {

  @Input() domainZoneID?: number;
  @Input() subdomainCase?: boolean;
  @Input() ipv4Address?: string;
  @Input() domainName?: string;
  @Input() fromDetails?: boolean;
  @Input() isDomainPointed?: boolean;
  @Input() defaultNameservers?: string[];

  public isCopied: any = [];
  public nameServers?: string[];
  public nsLoading: boolean;


  constructor(
    private readonly _activeModal: DbActiveModal,
    private _store: Store<fromStore.DbStoreState>,
  ) {
  }

  ngOnInit() {
    this._activeModal.whiteCloseBtn(true);
    this.nsLoading = this.fromDetails;
    if (this.domainZoneID) {
      this._loadDomainsAvailableZones(this.domainZoneID);
    } else {
      this.nsLoading = false;
    }
  }

  private _loadDomainsAvailableZones(domainZoneID): void {
    this._store.dispatch(new fromStore.LoadZone({zoneId: domainZoneID}));

    this._store
      .select(fromStore.getZone(domainZoneID))
      .pipe(
        filter((zone: any) => !!zone),
        distinctUntilChanged(),
      )
      .subscribe((zone: any) => {
        if (zone && !TypeUtils.isEmpty(zone)) {
          this.nameServers = zone && zone.zone && zone.zone.nameservers;
          this.nsLoading = false;
        }
      });
  }

  public copied(index: number) {
    this.isCopied[index] = true;
    setTimeout(() => this.isCopied[index] = false, 800);
  }

  public closeModal(): void {
    this._activeModal.close({success: true});
  }
}
